// src/components/GlobalToast.jsx
import React, { createContext, useContext, useState } from 'react';

const ToastContext = createContext();

export function useToast() {
  return useContext(ToastContext);
}

export function ToastProvider({ children }) {
  const [toast, setToast] = useState({ message: '', type: '' });
  const showToast = (message, type = 'info') => {
    setToast({ message, type });
    setTimeout(() => setToast({ message: '', type: '' }), 3000);
  };
  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toast.message && (
        <div className={`global-toast ${toast.type}`} role="alert" aria-live="assertive">
          <span>{toast.message}</span>
        </div>
      )}
    </ToastContext.Provider>
  );
}
